module.exports = __webpack_public_path__ + "static/media/background.ef58c577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.png
// module id = 327
// module chunks = 0